import HotkeysPreferences from './HotkeysPreferences.jsx';

export default HotkeysPreferences;
